import React, { Component } from 'react';

class getItems extends Component {

  mostrarItems = () => {
    const items = this.props.items;
    if(items.length === 0) return null;
    //<div  className="css_item">

    return (
      <React.Fragment>
        {items.map(item => (
          <span key={item.id_item} className="boton_item"><button className="boton_item_span" onClick={ () => this.props.recuperar_item(item.id_item, item.item,
             item.precio_venta, item.iva, item.servicio, item.w_incluido, item.id_rubro, item.id_subrubro, item.pfinal,item.id_combo,item.carga_maxima,
             item.preferencias
          )}>{item.item}</button></span>
        ) ) }
      </React.Fragment>
    )
  }

  render() {

    let data;
        if (this.props.ok_item===false) {
          data =<div className="div_lbl_loading"><img alt="Cargando Imagen . . ." className="lbl_loading" src={ require('../images/loading.gif') } /></div>
          //console.log(this.props.ok_item);
        } else {
          data = <React.Fragment>
            {this.mostrarItems()}
          </React.Fragment>
        }

    return (
      <React.Fragment>
            {data}
      </React.Fragment>
    );
  }
}
export default getItems;
